// extracted by mini-css-extract-plugin
module.exports = {"QueryStatsRadio":"QueryStatsRadio_kUNAo","QueryStatsExpanded":"QueryStatsExpanded_9u0ww","QueryStatsHeader":"QueryStatsHeader_vZa3H"};